import { useQuery } from '@tanstack/react-query';
import type { DirectoryListResponse } from '@stfors/shared-types';
import { api } from '../client';

// The unified directory: every company + every individual, with role badges.
export function useDirectory(opts?: { q?: string; role?: string }) {
  const q = (opts?.q ?? '').trim();
  const role = opts?.role ?? '';
  const params = new URLSearchParams();
  if (q) params.set('q', q);
  if (role) params.set('role', role);
  const qs = params.toString() ? `?${params.toString()}` : '';
  return useQuery({
    queryKey: ['directory', { q: q || null, role: role || null }],
    queryFn: ({ signal }) => api.get<DirectoryListResponse>(`/api/directory${qs}`, signal),
  });
}
